import Vue from 'vue';
import autocompleteItem from './item.vue';
export default Vue.extend({
    name: 'autocomplete',
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        rules: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: ''
        },
        emptyPlaceholder: {
            type: String,
            default: ''
        },
        maxDropHeightNormal: {
            type: String,
            default: '108px'
        },
        maxDropHeightAlphabetic: {
            type: String,
            default: '182px'
        },
        uppercase: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        touched: false,
        realValue: '',
        isOpen: false,
        isAlphabetic: false,
        selectedItemIndex: -1,
        textfieldErrors: [],
        scrollTo: {
            x: 0,
            y: 0
        }
    }),
    computed: {
        textfieldLabel() {
            return this.items.length === 0 ? this.emptyPlaceholder : this.placeholder;
        },
        foundItems() {
            return this.items.filter(({ label }) => {
                return label.toUpperCase().indexOf(this.value.toUpperCase()) > -1;
            });
        }
    },
    filters: {
        filtredItemLabel(item) {
            if (item.additionalValue) {
                return item.label + ' ' + item.additionalValue;
            }
            return item.label;
        }
    },
    methods: {
        handleButtonClick() {
            if (this.isAlphabetic) {
                this.dropClose();
            }
            else {
                this.dropOpen(true);
            }
        },
        handleTextfieldInput(v) {
            this.touched = true;
            this.$emit('change', this.uppercase ? v.toUpperCase() : v);
            this.textfieldErrors = [];
            this.selectedItemIndex = -1;
        },
        handleTextfieldEnter() {
            const selectedItem = this.foundItems[this.selectedItemIndex];
            if (selectedItem !== undefined) {
                this.$emit('change', selectedItem.label);
            }
            this.dropClose();
        },
        handleSelectPrev() {
            this.selectedItemIndex -= 1;
            if (this.selectedItemIndex < 0) {
                this.selectedItemIndex = this.foundItems.length - 1;
            }
            this.$nextTick(() => { this.scrollSelectedIntoView(); });
        },
        handleSelectNext() {
            this.selectedItemIndex += 1;
            if (this.selectedItemIndex > this.foundItems.length - 1) {
                this.selectedItemIndex = 0;
            }
            this.$nextTick(() => { this.scrollSelectedIntoView(); });
        },
        scrollSelectedIntoView() {
            const drop = this.$refs.drop;
            if (drop === undefined)
                return;
            const selectedItem = drop.querySelector('.autocomplete_drop_item__selected');
            const dropScroll = drop.querySelector('.autocomplete_drop_scroll');
            if (selectedItem === undefined || dropScroll === undefined)
                return;
            const dropBoundingClientRect = drop.getBoundingClientRect();
            const selectedItemBoundingClientRect = selectedItem.getBoundingClientRect();
            const currentPosition = dropScroll.getBoundingClientRect();
            if (dropBoundingClientRect.bottom - 2 < selectedItemBoundingClientRect.bottom) {
                this.scrollTo.y = selectedItemBoundingClientRect.bottom - currentPosition.bottom;
            }
            else if (dropBoundingClientRect.top + 4 > selectedItemBoundingClientRect.top) {
                this.scrollTo.y = selectedItemBoundingClientRect.top - currentPosition.top;
            }
        },
        handleItemClick(label) {
            this.touched = false;
            this.$emit('change', label);
            this.dropClose();
        },
        dropOpen(isAlphabetic) {
            this.isOpen = true;
            this.isAlphabetic = isAlphabetic;
            this.selectedItemIndex = -1;
        },
        dropClose() {
            if (this.$refs.textfield)
                this.$refs.textField.blur();
            this.isOpen = false;
            this.isAlphabetic = false;
            this.$nextTick(() => { this.validate(); });
        },
        validate() {
            this.rules.find((rule) => {
                const ruleVerdict = rule(this.value);
                if (ruleVerdict !== true) {
                    this.textfieldErrors = [ruleVerdict];
                    return true;
                }
                return false;
            });
        }
    },
    watch: {
        value(v) {
            if (!this.isOpen) {
                this.textfieldErrors = [];
                this.validate();
            }
        }
    },
    mounted() {
        const { autocompleteRootRef } = this.$refs;
        autocompleteRootRef.style.setProperty('--maxDropHeightNormal', this.maxDropHeightNormal);
        autocompleteRootRef.style.setProperty('--maxDropHeightAlphabetic', this.maxDropHeightAlphabetic);
        this.validate();
    },
    components: {
        'autocomplete-item': autocompleteItem
    }
});
